import { PreparedWorkload } from '../../../../../../workload-optimization/types';
import { isWorkloadOptimizationDisabled } from '../../../../_workloadStatusUtils';
import { WorkloadStatus } from '../../../../_components/WorkloadStatus';
import { useAppliedPodsDrawer } from '../../_hooks/useAppliedPodsDrawer';

export const StatusCell = (workload: PreparedWorkload) => {
  const { id, name, recommendationStatus } = workload;
  const { openAppliedPodsDrawer } = useAppliedPodsDrawer();

  return (
    <WorkloadStatus
      workload={workload}
      onAppliedStatusClick={() =>
        openAppliedPodsDrawer({
          workloadId: id,
          workloadName: name,
          appliedPods: recommendationStatus.appliedPods,
          totalPods: recommendationStatus.totalPods,
          isOptimizationDisabled: isWorkloadOptimizationDisabled(workload),
        })
      }
      testId="workload-status-cell"
    />
  );
};
